<template>
  <div class="action-buttons pt-4 mt-3 col-lg-11">
    <div class="form-group text-center text-lg-left pb-2">
      <div class="mb-3" v-if="canEdit">
        <SmagriaButton :label="$t('common.save')" customClass="primary" width="100%" :action="onSave" />
      </div>
      <div class="mb-3" v-if="canEdit && !uuid && saveAndNew">
        <SmagriaButton :label="$t('common.save_and_new')" customClass="success" width="100%" :action="onSaveAndNew" />
      </div>
      <div class="mb-3" v-if="uuid && canDelete">
        <SmagriaButton :label="$t('common.delete')" customClass="danger" width="100%" :action="onDelete" />
      </div>
      <div class="mb-3">
        <SmagriaButton :label="$t('common.back_to_list')" customClass="secondary" width="100%" :action="onGotoList" />
      </div>
    </div>
  </div>
</template>

<script>
import SmagriaButton from "@/components/Common/SmagriaButton.vue";

export default {
  name: 'AgroActionButtonsVertical',
  components: { SmagriaButton },
  props: {
    uuid: {
      type: String|null,
    },
    gotoList: {
      type: Function|null,
    },
    canEdit: {
      type: Boolean|null,
    },
    canDelete: {
      type: Boolean|null,
    },
    saveAndNew: {
      type: Boolean|null,
    },
  },
  methods: {
    onSave() {
      this.$emit('onSave');
    },
    onSaveAndNew() {
      this.$emit('onSaveAndNew');
    },
    onDelete() {
      this.$emit('onDelete');
    },
    onGotoList() {
      this.$emit('onGotoList');
    }
  }
}
</script>
